import { combineReducers } from 'redux';
import { jobsReducer } from './jobs';
import { filesReducer } from './files';

export const companyJobsReducer = combineReducers({
  jobs: jobsReducer,
  files: filesReducer,
});
